import { render } from "./buye.vue?vue&type=template&id=d0f010d0"
import script from "./buye.vue?vue&type=script&lang=js"
export * from "./buye.vue?vue&type=script&lang=js"

import "./buye.vue?vue&type=style&index=0&id=d0f010d0&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__